import { Button, Chip, Stack, TextField } from "@mui/material"
import { useState } from "react";

interface TagListProps {
    items: string[];
    onAdd: (value: string) => void;
    onRemove: (index: number) => void;
}

const TagList = (props: TagListProps) => {
    const [ newValue, setNewValue ] = useState("");

    const handleAdd = () => {
        props.onAdd(newValue);
        setNewValue("");
    }

    return <>
        <Stack direction="row">
            <TextField sx={{flexGrow: 1}} type="text" variant="standard" value={newValue} onChange={(event) => setNewValue(event.currentTarget.value)} />
            <Button onClick={handleAdd}>Add</Button>
        </Stack>
        <Stack flexWrap="wrap" useFlexGap direction="row" spacing={1}>
            {(props.items ?? []).map((value, index) => <Chip sx={{
    height: 'auto',
    '& .MuiChip-label': {
      display: 'block',
      whiteSpace: 'normal',
    },
  }} onClick={() => props.onRemove(index)} label={value} key={index} />)}
        </Stack>
    </>

}

export default TagList;